import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "displayConfig-title",
  "use": "displayConfig-title-usage",
  "viewBox": "0 0 63.81 63.81",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 63.81 63.81\" id=\"displayConfig-title\"><title>资源 105</title><g data-name=\"图层 2\"><path d=\"M55.84 0H8a8.3 8.3 0 0 0-8 8.31v47.57a7.93 7.93 0 0 0 7.92 7.93h48a7.93 7.93 0 0 0 7.92-7.93V8.31a8.3 8.3 0 0 0-8-8.31zM45.9 19.12H34.1v27.77a2.2 2.2 0 0 1-4.4 0V19.12H17.92a2.2 2.2 0 1 1 0-4.4h28a2.2 2.2 0 0 1 0 4.4z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/displayConfig-title.svg
// module id = ygNt
// module chunks = 6